<template>
  <v-app class="bgLightGreen boiler-page" id="inspire">
    <Header back header-text="lng_boiler"></Header>
    <flash-message
      v-if="alertToggle"
      :message-data="flashMessageData"
      :alert-toggle="alertToggle"
      :do-translation="false"
      @alertToggleUpdate="flashMessageTimeOut()"
    >
    </flash-message>
    <v-container fluid v-if="boilerMenu">
      <app-menu page-name="Boiler"></app-menu>
      <v-layout row wrap justify-center>
        <v-flex
          v-for="subMenu in boilerMenu.menu.submenu"
          :key="subMenu['@attributes'].txtid"
          xs12
          md6
          class="px-4 panel-block"
        >
          <sub-menu
            v-if="subMenu && boilerMenuData"
            :sub-menu="subMenu"
            :sub-menu-data="boilerMenuData"
            :sub-menu-select-data="boilerMenu.fieldsets.fieldset"
            :response-alert="setResponseAlert"
            :sub-menu-output-setting="filteredOutputSettings"
            @openTimerPage="openTimerPage"
          ></sub-menu>
        </v-flex>
      </v-layout>
    </v-container>
    <refresh-timer
      v-if="showTimer"
      :refresh-time="pageRefreshTime"
      :refresh-page="refreshPage"
      :show-count-down="true"
      :key="timerKey"
    ></refresh-timer>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import Header from "../components/Header";
import SubMenu from "../components/SubMenu";
import RefreshTimer from "../components/RefreshTimer";
import GlobalService from "../services/global-service";
import Menu from "../components/menus/Menu";
import FlashMessage from "../components/FlashMessage";
import { translate } from "../common/HelperFunctions";
import router from "../router";

export default {
  //component to add "Header", "Submenues", "Refresh page timer" and "boiler menu"
  components: {
    Header,
    SubMenu,
    RefreshTimer,
    appMenu: Menu,
    FlashMessage
  },
  data: () => ({
    boilerMenu: undefined,
    boilerMenuData: undefined,
    boilderSelectData: [],
    alertToggle: false,
    flashMessageData: {},
    responseObj: {},
    outputSettings: undefined,
    filteredOutputSettings: [],
    pageRefreshTime: 30,
    timerKey: 0,
    showTimer: false
  }),
  async created() {
    // start page loading component
    this.$store.commit("global/setLoading", true);
    await this.FetchApisData();
  },
  mounted() {
    document.getElementsByTagName("html")[0].className = "";
  },
  computed: {
    ...mapGetters("user", ["getUser"])
  },
  methods: {
    // fetch api's data needed in boiler's page
    async FetchApisData() {
      this.outputSettings = await GlobalService.getOutputSettings(
        this.getUser.token
      );
      this.boilerMenu = await GlobalService.getMenu(
        "boiler",
        this.getUser.token
      );
      this.boilerMenuData = await GlobalService.getMenuData(
        "boiler",
        this.getUser.token
      );
      this.filterOutputSettings();
      this.showTimer = true;
      this.$store.commit("global/setLoading", false);
    },
    // to show the resposne alert on update field
    setResponseAlert(resObj) {
      this.alertToggle = true;
      this.responseObj = resObj;
      this.flashMessageData = {
        saved: resObj.onlineandsaved ? "lng_save_ok" : "lng_save_notok",
        messageText: resObj.onlineandsaved
          ? `${translate("lng_save_ok")}`
          : `${translate("lng_save_notok")}`,
        showRegisterButton: false,
        color: resObj.onlineandsaved ? "rgba(76, 175, 80, 0.9)" : "red"
      };
      if (resObj.secs_to_next_update > 0) {
        this.pageRefreshTime = resObj.secs_to_next_update;
      }
      this.timerKey += 1;
    },
    flashMessageTimeOut() {
      this.alertToggle = false;
      this.responseObj = {};
    },
    // filter data for Alarm output dropdown field
    filterOutputSettings() {
      this.outputSettings.forEach(setting => {
        if (setting.txt !== "") {
          this.filteredOutputSettings.push(setting);
        }
      });
      this.filteredOutputSettings.unshift({ id: 0, txt: "" });
    },
    // a funtion to refresh the page after specific time
    async refreshPage() {
      await this.FetchApisData();
      this.pageRefreshTime = 30;
      this.timerKey += 1;
    },
    openTimerPage() {
      router.push("/boiler/boiler-timer");
    }
  }
};
</script>
